export default __webpack_public_path__ + "static/media/method-icon.a3f8e695.svg";